import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase.config.js";
import Spinner from "./Spinner";
import { collection, query, limit, orderBy, getDocs } from "firebase/firestore";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import "swiper/css";
import { Pagination } from "swiper";

function Slider() {
  const [loading, setLoading] = useState(true);
  const [listings, setListings] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchListing = async () => {
      const listingsRef = collection(db, "listings");
      const q = query(listingsRef, orderBy("timestamp", "desc"), limit(5));
      const querySnap = await getDocs(q);

      let listings = [];

      querySnap.forEach((docs) => {
        return listings.push({
          id: docs.id,
          data: docs.data(),
        });
      });
      setListings(listings);
      setLoading(false);
    };

    fetchListing();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  if (listings.length === 0) {
    return <></>;
  }
  return (
    listings && (
      <>
        <p className="exploreHeading">Recommanded</p>

        <Swiper
          slidesPerView={1}
          pagination={true}
          modules={[Pagination]}
          className="swiper-container"
        >
          {listings.map(({ data, id }) => (
            <SwiperSlide
              key={id}
              onClick={() => navigate(`/category/${data?.type}/${id}`)}
            >
              <div
                style={{
                  position: "relative",
                  background: `url(${data?.imgUrls[0]}) center no-repeat`,
                  backgroundSize: "cover",
                  width: "100%",
                  height: "100%",
                }}
                className="swiperSlideDiv"
              >
                <p className="swiperSlideText">{data?.name}</p>
                <p className="swiperSlidePrice">
                  ${data?.discountedPrice ?? data?.regularPrice}{" "}
                  {data?.type === "rent" && "/ month"}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </>
    )
  );
}

export default Slider;
